import * as Yup from 'yup';

export const OTHER_OCCUPATION_OPTION = 'Other';

export const OCCUPATION_OPTIONS = [
  'Student',
  'Manager',
  'Retired',
  'Engineer',
  OTHER_OCCUPATION_OPTION,
] as const;

export type OccupationOption = (typeof OCCUPATION_OPTIONS)[number];

const PRESET_OCCUPATIONS = OCCUPATION_OPTIONS.filter(
  (option) => option !== OTHER_OCCUPATION_OPTION
);

export function resolveOccupationOption(occupation: string): OccupationOption | '' {
  const trimmed = occupation.trim();
  if (!trimmed) {
    return '';
  }

  const match = PRESET_OCCUPATIONS.find(
    (option) => option.toLowerCase() === trimmed.toLowerCase()
  );
  return match ?? OTHER_OCCUPATION_OPTION;
}

export const occupationSchema = Yup.string()
  .min(3, 'Minimum 3 characters')
  .max(50, 'Maximum 50 characters')
  .required('Occupation is required')
  .test('hasText', 'Occupation cannot be only spaces', (value) => {
    return /\S/.test(value || '');
  })
  .test('not-other', 'Please enter your occupation', (value) => {
    return value?.trim().toLowerCase() !== OTHER_OCCUPATION_OPTION.toLowerCase();
  })
  .matches(/^[a-zA-Z\-_\s]+$/, 'Occupation must contain only letters');
